import { translate } from 'hooks/useTranslate';
import { PartnerCategory } from 'types';

type GetCategoryLabelProps = {
  categoryId: string;
  partnerCategories: PartnerCategory[];
};

export const getCategoryLabel = ({
  categoryId,
  partnerCategories,
}: GetCategoryLabelProps): string => {
  if (!partnerCategories || !categoryId) return '';

  const category = partnerCategories.find((item) => item._id === categoryId);

  if (!category) return '';

  return category?.isDefault ? translate(category?.name) : category.name;
};
